import React from 'react';
import { Pricing } from './Pricing';
import TopBar from './common/home/TopBar';
import Footer from './common/home/Footer';
import MainContent from './MainContent';
import { useAuth } from '../state/AuthContext';
import Box from '@mui/material/Box';

export default function PricingPage() {
  const { apiToken, backendToken } = useAuth();
  const isLoggedIn = !!(apiToken || backendToken);

  if (isLoggedIn) {
    return <MainContent />;
  }

  return (
    <div className="pricing-page" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#F8F9FA' }}>
      <TopBar />
      <Box sx={{ flex: 1, py: 6 }}>
        <Pricing />
      </Box>
      <Footer />
    </div>
  );
}
